import type { AnswerSet } from "@/models/answerSet";
import { AnswerSetDto } from "@/models/dto/answerSetDto";
import type { QuestionnaireItemSetDto } from "@/models/dto/questionnaireItemSetDto";
import axios from "axios";

export const saveAnswerSet = async (
  set: QuestionnaireItemSetDto
): Promise<AnswerSet> => {
  const answerSet = new AnswerSetDto();
  answerSet.questionSetId = set.id;
  answerSet.contextId = set.contextId;
  answerSet.contextIds = set.contextIds;
  answerSet.answerStatus = set.answerStatus;

  for (const itemRow of set.items) {
    for (const item of itemRow) {
      answerSet.answers[item.questionModel.question.id] =
        item.answers as object;
    }
  }

  const resp = await axios.post<AnswerSet>(
    "/api/answers/save-answer-set",
    answerSet
  );
  return resp.data;
};

export const submitAnswerSet = async (
  set: QuestionnaireItemSetDto
): Promise<AnswerSet> => {
  const answerSet = new AnswerSetDto();
  answerSet.questionSetId = set.id;
  answerSet.contextId = set.contextId;
  answerSet.contextIds = set.contextIds;
  answerSet.answerStatus = set.answerStatus;
  answerSet.submitWithNonCompletedAnswers = set.submitWithNonCompletedQuestions;

  for (const itemRow of set.items) {
    for (const item of itemRow) {
      answerSet.answers[item.questionModel.question.id] =
        item.answers as object;
    }
  }

  const resp = await axios.post<AnswerSet>(
    "/api/answers/submit-answer-set",
    answerSet
  );
  return resp.data;
};

export const cloneAnswerSet = async (
  sourceQuestionnaireId: string,
  targetQuestionnaireIds: string[]
): Promise<void> => {
  const resp = await axios.post("/api/answers/clone-answers", {
    sourceQuestionnaireId: sourceQuestionnaireId,
    targetQuestionnaireIds: targetQuestionnaireIds,
  });

  return resp.data;
};
